export const chartColors: string[] = ["#A926FF","#9907FA","#801FC0","#7500C3","#A658FF","#7d00d0","#6D00B6","#450073","#370617","#03071e"]
export const chartColors2: string[] = ["#ff2700","#0000ff","#f8ff4d","#2185ff","#00ff61","#f8fa3d","#bb796d","#36b7e9","#ffbe24","#ff7100"]
